export enum SizeEnum {
	X_LARGE = 'xl',
	LARGE = 'l',
	MEDIUM = 'm',
	SMALL = 's'
}

export const SIZE_ENUM_VALUES = Object.values(SizeEnum);
